import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: `0 0 ${_ctx.puzzle.block.w} ${_ctx.puzzle.block.h}`,
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    _createElementVNode("rect", {
      x: "0",
      y: "0",
      height: _ctx.puzzle.block.h,
      width: _ctx.puzzle.block.w,
      fill: "transparent",
      stroke: "black",
      "stroke-width": "0.1"
    }, null, 8 /* PROPS */, ["height", "width"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle.bits, (bit) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (bit.id !== _ctx.puzzle.candidate?.id)
          ? (_openBlock(), _createElementBlock("image", {
              key: 0,
              x: bit.block.x,
              y: bit.block.y,
              height: bit.block.h,
              width: bit.block.w,
              "xlink:href": _ctx.getBitImage(bit),
              style: {"image-rendering":"pixelated"}
            }, null, 8 /* PROPS */, ["x", "y", "height", "width", "xlink:href"]))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 256 /* UNKEYED_FRAGMENT */)),
    (_ctx.puzzle.candidate)
      ? (_openBlock(), _createElementBlock("image", {
          key: 0,
          x: _ctx.puzzle.candidate.block.x,
          y: _ctx.puzzle.candidate.block.y,
          height: _ctx.puzzle.candidate.block.h,
          width: _ctx.puzzle.candidate.block.w,
          "xlink:href": _ctx.getBitImage(_ctx.puzzle.candidate),
          style: {"image-rendering":"pixelated"}
        }, null, 8 /* PROPS */, ["x", "y", "height", "width", "xlink:href"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("image", {
      x: _ctx.puzzle.latch.block.x,
      y: _ctx.puzzle.latch.block.y,
      height: _ctx.puzzle.latch.block.h,
      width: _ctx.puzzle.latch.block.w,
      "xlink:href": "latch.png",
      style: {"image-rendering":"pixelated"}
    }, null, 8 /* PROPS */, ["x", "y", "height", "width"])
  ], 8 /* PROPS */, ["viewBox"]))
}